import { Stack, Typography } from 'components/ui';
import { InlineSpan } from 'components/styles_components/span';
import React from 'react';

const Inspector = ({ inspector }) => {
  if (!inspector) {
    return '-';
  }

  return (
    <InlineSpan>
      <Stack textAlign="left">
        <Typography>
          {inspector.name} {inspector.surname}
        </Typography>
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          {inspector.email}
        </Typography>
      </Stack>
    </InlineSpan>
  );
};

export default Inspector;
